// src/middleware/auth.js

//dependencies
import Vue from 'vue';
import store from '../store/store';

export async function authMiddleware(to, from, next){
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['login', 'registerEmail', 'registerVerification', 'registerToken', 'passwordEmail', 'passwordVerification', 'passwordToken'];
  const authRequired = !publicPages.includes(to.name);
  let session = $cookies.get('session');
  let token = $cookies.get('token');
  let loggedIn = false;

  if(session){
    if(!Object.keys(store.state.host).length){
      await store.dispatch('set');
    }
    if(!token){
      Vue.prototype.$logout();
    }
    loggedIn = true;
    //const base64Host = session.split('.')[1];
    //const decoded = JSON.parse(Buffer(base64Host, 'base64').toString('utf8'));
    //Vue.prototype.$host = decoded.host;
    if(!authRequired){
      return next('/');
    }

    //make calendar default view
    if(to.path == '/' || to.path == '/sl'){
      if(store.state.host.properties.length){
        if(store.state.host.properties[0].rooms &&  store.state.host.properties[0].rooms.length){
          return next('/sl/' + store.state.host.properties[0].slug + '/koledar');
        }
        return next('/sl/' + store.state.host.properties[0].slug + '/sobe');
      }else{
        return next('/sl/nastavitve/nastanitve/ustvari');
      }
    }
    return next();

  }else if(token){
    //get access token from refresh token token
    Vue.prototype.$getAccessToken()
    .then(response => {
      return next(to.path);
    });
  }else{
    store.commit('update');
    if(authRequired){
      return next('/login');
    }
    return next();
  }
}
